import invert from 'lodash/invert';
import {TicketTypeVo} from '../../common/shared/api/nicolas/vo/TicketTypeVo.enum';
import {TicketType} from '../generated/types';

export function createTicketType(ticketTypeVo: TicketTypeVo): TicketType {
  return mapper[ticketTypeVo];
}
export function createTicketTypeVo(ticketType: TicketType): TicketTypeVo {
  return invertMapper[ticketType] as TicketTypeVo;
}

const mapper: {[key in TicketTypeVo]: TicketType} = {
  [TicketTypeVo.BuyCampaign]: TicketType.BuyCampaign,
  [TicketTypeVo.BuyCoupon]: TicketType.BuyCoupon,
  [TicketTypeVo.BuyEvent]: TicketType.BuyEvent,
  [TicketTypeVo.BuyGiftFree]: TicketType.BuyGiftFree,
  [TicketTypeVo.BuyMoviePpv]: TicketType.BuyMoviePpv,
  [TicketTypeVo.BuyNewCustomerGift]: TicketType.BuyNewCustomerGift,
  [TicketTypeVo.BuyPackage]: TicketType.BuyPackage,
  [TicketTypeVo.BuySingle]: TicketType.BuySingle,
  [TicketTypeVo.BuyTodayGift]: TicketType.BuyTodayGift,
  [TicketTypeVo.BuyWaitFree]: TicketType.BuyWaitFree,
  [TicketTypeVo.BuyWaitFreePlus]: TicketType.BuyWaitFreePlus,
  [TicketTypeVo.BuyCashSingle]: TicketType.BuyCashSingle,
  [TicketTypeVo.BuyCashDiscountSingle]: TicketType.BuyCashDiscountSingle,
  [TicketTypeVo.BuySet]: TicketType.BuySet,
  [TicketTypeVo.Deactivate]: TicketType.Deactivate,
  [TicketTypeVo.Premium]: TicketType.Premium,
  [TicketTypeVo.RentCampaign]: TicketType.RentCampaign,
  [TicketTypeVo.RentCoupon]: TicketType.RentCoupon,
  [TicketTypeVo.RentEvent]: TicketType.RentEvent,
  [TicketTypeVo.RentGiftFree]: TicketType.RentGiftFree,
  [TicketTypeVo.RentMoviePpv]: TicketType.RentMoviePpv,
  [TicketTypeVo.RentNewCustomerGift]: TicketType.RentNewCustomerGift,
  [TicketTypeVo.RentPackage]: TicketType.RentPackage,
  [TicketTypeVo.RentSingle]: TicketType.RentSingle,
  [TicketTypeVo.RentTodayGift]: TicketType.RentTodayGift,
  [TicketTypeVo.RentWaitFree]: TicketType.RentWaitFree,
  [TicketTypeVo.RentWaitFreePlus]: TicketType.RentWaitFreePlus,
  [TicketTypeVo.RentCashSingle]: TicketType.RentCashSingle,
  [TicketTypeVo.RentCashDiscountSingle]: TicketType.RentCashDiscountSingle,
  [TicketTypeVo.RentSet]: TicketType.RentSet,
  [TicketTypeVo.WebSeries]: TicketType.WebSeries,
};

const invertMapper = invert(mapper);
